import PostContents from './PostContents';

export default PostContents;
export * as PostContentsStyles from './PostContents.styles';
export * as PostContentsTypes from './PostContents.types';
